import { render } from "./FireEditForm.vue?vue&type=template&id=0f06b25a"
import script from "./FireEditForm.vue?vue&type=script&lang=ts"
export * from "./FireEditForm.vue?vue&type=script&lang=ts"
script.render = render

export default script